// src/stores/auth.js
import { defineStore } from 'pinia';
import axios from '@/plugins/axios'; // Configura tu instancia de Axios con baseURL

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: null,
  }),
  actions: {
    async login(credentials) {
      try {
        console.log('/auth/login-user')
        const response = await axios.post('/auth/login-user', credentials); // Cambia la ruta según tu backend
        this.user = response.data.user;
        this.token = response.data.token;
        // Guarda el token en localStorage para mantener la sesión
        localStorage.setItem('userToken', this.token);
        // Opcional: redirigir al usuario al dashboard después del login
        window.location.href = '/dashboard';
      } catch (error) {
        console.log('Error al iniciar sesión:', error.response?.data?.error || error.message);
        throw error;
      }
    },
    logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem('userToken');
      window.location.href = '/login'; // Redirigir al login
    },
  },
});
